/**
 * List Schema of ReponsavelAssociado
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {ReponsavelAssociado} from '@/model/resource/ReponsavelAssociado'

/* TODO: review generated schema */
export class ListReponsavelAssociadoSchema extends Schema {
  readonly name = 'ListReponsavelAssociado'

  readonly fieldSet: FieldSet<ReponsavelAssociado> = {
    idAssociadoPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    responsavel: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.responsavel?.$id,
      },
    }),
    razaoSocial: (): FieldComponent => ({
      is: Component.Render,
    }),
    nomeFantasia: (): FieldComponent => ({
      is: Component.Render,
    }),
    cnpj: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.cnpj(schema.model.cnpj),
      },
    }),
    ativo: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.ativo),
      },
    }),
  }
}
